module.exports = __webpack_public_path__ + "static/media/menuHelp.1aa7406d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuHelp.svg
// module id = 169
// module chunks = 0